import React from 'react';

import { useCuration } from '@hooks/useCuration';
import { useFeatureFlags } from '@hooks/useFeatureFlags';

import BaseLayout from './BaseLayout';
import { processViewSettings } from './util';

const PRACTITIONER_SETTINGS = [
  [
    'home',
    'patients',
    'alerts',
    'assessments',
    'shareHistory',
    'appInformation',
  ],
] as const;

const PractitionerLayout: React.FC<{
  friendlyName?: string | null;
  children: React.ReactNode;
  loading?: boolean;
  showHeader?: boolean;
}> = ({
  friendlyName,
  children = null,
  loading = false,
  showHeader = false,
}) => {
  const {
    state: { patientView },
  } = useCuration();
  const { flags } = useFeatureFlags();

  const PRACTITIONER_SETTINGS_MOBILE = processViewSettings([
    [['home', true]],
    [['patients', true]],
    [['alerts', true]],
    [['shareHistory', true]],
    [['messenger', flags.isMessengerUseChatEnabled]],
  ]);

  const PRACTITIONER_PATIENT_VIEW_SETTINGS = processViewSettings([
    [['backToPatients', true]],
    [['patientOverview', true]],
    [
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['reminders', true],
      ['profile', true],
      ['contacts', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
      ['healthDevices', true],
      ['shareHistory', true],
      ['report', true],
      ['more', true],
      ['appInformation', true],
    ],
  ]);

  const PRACTITIONER_PATIENT_VIEW_SETTINGS_MOBILE = processViewSettings([
    [
      ['backToPatients', true],
      ['patientOverview', true],
      ['home', true],
      ['alerts', true],
      ['records', true],
      ['timeline', true],
      ['messenger', flags.isMessengerUseChatEnabled],
      ['routines', true],
      ['summary', true],
      ['assessments', flags.isAssessmentListAssessmentsEnabled],
    ],
  ]);

  return (
    <BaseLayout
      friendlyName={friendlyName}
      loading={loading}
      showHeader={showHeader}
      settings={{
        desktop: patientView
          ? PRACTITIONER_PATIENT_VIEW_SETTINGS
          : PRACTITIONER_SETTINGS,
        mobile: patientView
          ? PRACTITIONER_PATIENT_VIEW_SETTINGS_MOBILE
          : PRACTITIONER_SETTINGS_MOBILE,
      }}
    >
      {children}
    </BaseLayout>
  );
};

export default PractitionerLayout;
